// extracted by mini-css-extract-plugin
module.exports = {"dialog":"modal_dialog__lEo6t","closeBtn":"modal_closeBtn__oRfD2","fade-in":"modal_fade-in__llPJN"};